<template>
    <div>
        <smallbutton @click="Updateseating()" :toplabel="updateText" :class="buttonclass"/>
        <!-- ACCT NOTE MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form ref="myform">
                    <label class="titlelabel">{{updateText}}</label>
                    
                    <!-- if existing recurring, figure out if we are editing just this one, or the whole set -->
                    <div v-if="isExistingRecurring && !okToUpdateRecurring && !hasReservations">
                        
                        <label >This instance is recurring. Do you want to update only this instance or the entire set of recurring seatings?</label>
                        <br>
                        
                        <smallbutton  @click="updateThisSeating()" toplabel="This Instance"/>
                        <smallbutton  @click="updateSetOfSeatings()" toplabel="Entire Set"/>
                        <smallbutton  @click="cancelupdate()" toplabel="Cancel"/>
                        <div>
                            <label class="responsemessage">{{message}}</label>
                        </div>
                        
                    </div>
                    <div v-if="hasReservations">
                        <label class="negative">This instance has reservations associated with it and may not be updated. Please reschedule/cancel those reservations before updating this instance.</label>
                        <br>
                        <smallbutton  @click="cancelupdate()" toplabel="Close"/>
                    </div>
                    <div v-if="!hasReservations && (!isExistingRecurring || okToUpdateRecurring)">
                        <div class="entry"  v-if="isVisible('IsActive')">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Is Active</label>
                            </div>
                            <div class="entryTextDiv">
                                <input class="entryCheckbox" type="checkbox" v-model="seating.isActive" >
                            </div>
                        </div>
                        
                        <div class="entry"  v-if="isVisible('IsRecurring')" >
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Is Recurring</label>
                            </div>
                            <div class="entryTextDiv">
                                <input class="entryCheckbox" type="checkbox" v-model="seating.isRecurring" :disabled="seating.id>0">
                            </div>
                        </div>

                        <div class="entry" v-if="isVisible('Type')">
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Type</label>
                            </div>
                            <div class="entryTextDiv">
                            <select name="" id="" class='entrySelectseating' v-model="seating.seatingTypeId"  :required="isRequired('Address')" @change="selecttype">
                                <option v-for="t in activeseatingTypeList" :key="t.id" :value="t.id" >
                                    {{t.name}}
                                </option>
                            </select>
                            </div>
                        </div>



                        <formentry  inputtype="date"  label="Date" :isrequired="isRequired('Date')"  v-model="seating.seatingDateTime" v-if="!seating.isRecurring" @change="updatename"/>
                        <formentry  inputtype="number"  label="Seats Available" :isrequired="isRequired('Date')"  v-model="seating.seatsAvailable" />
                        <div class="entry" v-if="isVisible('Type')">
                            <div class="entryTextDiv"></div>
                            <div class="entryTextDiv">
                                <label class="daylabel" for="">{{ dayofweek }}</label>
                            </div>
                        </div>
                        
                        <!-- <formentry  inputtype="text"  label="Name" :isrequired="isRequired('Name')"  v-model="seating.name" v-if="!seating.isRecurring"/> -->

                        
                        <div v-if="seating.isRecurring">
                            <formentry  inputtype="date"  label="Start Date" :isrequired="seating.isRecurring"  v-model="recurringStart"  />
                            <formentry  inputtype="date"  label="End Date" :isrequired="seating.isRecurring"  v-model="recurringEnd"  />
                        </div> 

                        <smallbutton buttonclass="button buttonsave"  @click="saveNewseating()" toplabel="Save" v-if="!needConfirm"/>
                        <smallbutton  @click="saveNewseating(true)" toplabel="Confirm Save" v-if="needConfirm"/>
                        <smallbutton buttonclass="button buttoncancel" @click="cancelupdate()" toplabel="Cancel"/>
                        <div>
                            <label class="responsemessage">{{message}}</label>
                        </div>
                    </div>
                    

                   <!-- <confirm ref="overrideDuplicate" :showButton="paramFalse" :body="confirmseatingMessage" title="Add seating" @yes="saveNewseating(true)"   /> -->
              </form>

            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import datamethods from '../../services/datamethods.js'
    import format from '../../format.js'
    import smallbutton from '../controls/button.vue'
    import actionmodal from '../actions/actionmodal.vue'
    import formentry from '../controls/entry.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import pencilbutton from '../controls/pencilbutton.vue'

    export default {
        name:'updateseating',
        components:{
            smallbutton,
            actionmodal,
            formentry,
            linkbutton,
            pencilbutton,
            
        },
        props:{
            inseating:{
                type:Object,
                required:true
            },
       
            isAdd:{
                type:Boolean,
                default:false
            },
            buttonclass:{
                type:String,
                default:'updatebutton'
            },
 
    
        },
        mixins:[datamethods,format],
        data(){
            return{
                message:'',
                seating:{
                    id:0,
                    name:null,
                    isActive:true,
                    seatingTypeId:0,
                    isRecurring:false
                },
                confirmseatingMessage:null,
                selectedSeatingName:null,
                dayofweek:null,
                recurringStart:null,
                recurringEnd:null,
                okToUpdateRecurring:false
            }
            
        },
        computed:{
            ...mapFields([
               'locationList',
               'seatingTypeList'
            ]),
           
            updateText(){
                if(this.isAdd){
                    return "Add Seating" 
                }else{
                    return "Update Seating" 
                }
                
            },
            activeseatingTypeList(){
                var filtered =[]

                    this.seatingTypeList.forEach(myFunction2)
                
                    function myFunction2(item, index, arr) {
                        let t=arr[index]
                        if(t.isActive ){
                            filtered.push(t)
                        }
                    } 
                    return filtered
            },
            hasReservations(){
                return this.seating.seatsReserved>0
            },
            isExistingRecurring(){
                return this.seating.isRecurring && this.seating.id>0
            }
        },
        methods:{
            updateThisSeating(){
                //no longer recurr
                this.message=null
                this.seating.isRecurring=false
                this.seating.seatingId_Recurring=0

            },
            async updateSetOfSeatings(){
                //if this is recurring, we need to check and see if there are reservations
                this.message=null
                let req = {

                    seating:{seatingId_Recurring:this.seating.seatingId_Recurring}
                }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'seatingswithreservations')
                //handle response
            
                if(response.Successful){
                    if(response.ResponseInteger==0){
                        this.okToUpdateRecurring=true
                    }else{
                        this.message = "One or more of the instances in this recurring set have reservations associated with them. Please reschedule/cancel those reservations before updating the recurring set."
                    }
                    
                    
                }else{
                    this.message = response.Message
                }
                this.pleaseWait=false;   
                
            },
            selecttype(){
                var mythis =this
                console.log('seltype ' + this.seating.seatingTypeId)
                this.seatingTypeList.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if(t.id==mythis.seating.seatingTypeId){   
                        mythis.selectedSeatingName=t.name
                        mythis.seating.seatsAvailable=t.seatsAvailable
                        mythis.seating.seatsReserved=0
                        mythis.seating.seatingTypeName=t.name
                    } 
                }
                this.seating.typeIsDirty=true
                this.updatename()
            },
            updatename(){
                //if(this.seating.name!=null){return}
                console.log('updatename ' + this.seating.seatingTypeId + ' ' + this.seating.seatingDateTime)
                if(this.seating.seatingTypeId>-1 && this.seating.seatingDateTime!=null){
                    var newdt = this.$options.filters.formatDateShort_Dashes(this.seating.seatingDateTime)
                    this.seating.name=this.selectedSeatingName + ' ' + newdt
                    this.dayofweek = this.$options.filters.dayOfWeek(this.seating.seatingDateTime)
                    console.log('updatename ' + this.seating.name)
                }
            },
            toCurrency(value){
                return "$" + Number(value).toFixed(2);
            },
            isRequired(field){
                
                switch (field) {
                    case "Name":
                        return true
                        break;
                    

                    default:
                        return false
                        break;
                }
            },
            isVisible(field){
                
               // console.log('isvis ' + field)
                switch (field) {
         
                    default:
                        return true
                        break;
                }
            },
            toCurrency(value){
                return  Number(value).toFixed(2);
            },
           async Updateseating(){
            this.okToUpdateRecurring=false
            this.needConfirm=false
            this.message=null
            this.dayofweek=null
            this.recurringStart=null
            this.recurringEnd=null
            if(this.isAdd){
                this.seating = {
                    id:0,
                    name:null,
                    isActive:true,
                    seatingTypeId:0,
                    seatsAvailable:0,
                    seatsReserved:0,
                    isRecurring:false,
                    seatingTypeName:null
                    
              
                }
                
            }else{
                

                this.seating = this.inseating
                
                //refresh
                this.message = ''
                let req = {
                    seatingId:this.seating.id
                }
                var response = await this.callAPI(req,'seating')    
                if(response.Successful){
                    this.seating=response.Seating
                    this.seating.seatingDateTime = this.$options.filters.formatDateForInput(this.seating.seatingDateTime)
                    this.recurringStart = this.$options.filters.formatDateForInput(this.seating.recurringStartDate)
                    this.recurringEnd = this.$options.filters.formatDateForInput(this.seating.recurringEndDate)
                    this.selectedSeatingName=this.seating.seatingTypeName
                }else{
                    this.message = response.Message
                }
                
                
                


            }
            

            this.$refs.mymodal.openModal()
           },
            
            checkClass(selected){
                if(selected){
                    return "entryCheckLabelbold"
                }else{
                    return "entryCheckLabel"
                }
            },
            cancelupdate(){
                this.$refs.mymodal.closeModal()
                this.$emit('refresh', this.seating.id)
                
            },
            async saveNewseating(){
                this.message=null
                if(this.$refs.myform.checkValidity()==false){
                    this.message = "Please fill in all required fields"
                    return}
                
                
                this.seating.locationId=-1
                
                //apply change to all if is recurr and has id
                var applyToAll=false
                if(this.seating.isRecurring ){
                    applyToAll=true
                }

                let req = {
                    seating:this.seating,
                    applyChangeToall:applyToAll
                }

                //if recurring, add the start/end dates to the request
                if(this.seating.isRecurring){
                    req.recurringStart=this.recurringStart
                    req.recurringEnd=this.recurringEnd
                }
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'updateseating')
                if(response.Successful){
                    this.needConfirm=false
                    this.$refs.mymodal.closeModal()
                    //console.log(response)
    
                    if(this.isAdd){
                        this.$emit('refreshnew',response.ResponseInteger)
                    }else{
                        if(this.seating.id !=response.ResponseInteger){this.seating.id=response.ResponseInteger}
                        this.$emit('refresh',this.seating.id)
                    }
                    
                }else{
                    if(response.Message.includes('Do you want to add anyway?')){
                        this.message = response.message
                        this.needConfirm=true
                    }
                    this.message = response.Message
                }
                this.pleaseWait=false;
            },
            
             
           
            
           
        },
        mounted(){
            
        }
    }
    </script>
    
    <style>
    .entrySelectseating{
    margin:5px 5px 5px 5px;
    width:100%;
    height:25px;
    font-size:inherit;
}
    .entryCheckLabel{
        margin:0px 0px 0px 5px;
        font-size:medium;
        text-align: left;  
        max-width: 420px;
    }
    .entryCheckLabelbold{
        margin:0px 0px 0px 5px;
        font-size:medium;
        text-align: left;  
        max-width: 420px;
        font-weight:bold;
    }
    .updatebutton{
        height:30px;
        width:150px;
        border-radius: 5px;
        padding:3px;
        margin:0px 0px 10px 0px;
    }
    .locationcheck{
    height:15px;
    margin-top:15px;
    margin-right:5px;
}
.locationdiv{
    text-align: left;
    display:grid;
    grid-template-columns: 1fr 15fr;
}
.locationCheckbox{
    height:15px;
    margin-top:15px;
}
.daylabel{
    margin-left:10px;
}

    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    